import { InitPage } from "../index";
import swal from "sweetalert";

class BulkActions {
  init() {
    $("#select_all").on("change", function (e) {
      // @ts-ignore
      const checked = e.target.checked;
      $('input[type="checkbox"].geigers-checkbox:not(:disabled)').prop(
        "checked",
        checked,
      );
      if (checked) {
        $("#bulk-delete-btn").removeClass("disabled");
      } else {
        $("#bulk-delete-btn").addClass("disabled");
      }
    });

    $(".geigers-checkbox").on("change", function () {
      const checked =
        $('input[type="checkbox"].geigers-checkbox:not(:disabled)').length ===
        $(".geigers-checkbox:not(:disabled):checked").length;
      $("#select_all").prop("checked", checked);
      if ($(".geigers-checkbox:not(:disabled):checked").length === 0) {
        $("#bulk-delete-btn").addClass("disabled");
      } else {
        $("#bulk-delete-btn").removeClass("disabled");
      }
    });

    $(document).on("click", "#bulk-delete-btn", function (e) {
      e.preventDefault(); // Prevent default link behavior

      const selectedIds = $(".geigers-checkbox:checked")
        .map(function () {
          return $(this).val();
        })
        .get();

      if (selectedIds.length === 0) {
        alert("Please select at least one item.");
        return;
      }

      swal({
        title: "Are you sure?",
        text: "This operation will delete all the selected Geiger List(s)",
        icon: "warning",
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: "No",
            value: null,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-silver",
            closeModal: true,
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "sn-btn sn-btn-sm sn-btn-red",
            closeModal: true,
          },
        },
        dangerMode: true,
      }).then((willConfirm) => {
        if (willConfirm) {
          const baseUrl = $(this).data("base-url");

          // Create a form to submit the DELETE request
          const form = $("<form>", {
            method: "POST",
            action: baseUrl,
          });

          // Add CSRF token if available
          const csrfToken = $('meta[name="csrf-token"]').attr("content");
          if (csrfToken) {
            form.append(
              $("<input>", {
                type: "hidden",
                name: "authenticity_token",
                value: csrfToken,
              }),
            );
          }

          // Add method override for DELETE
          form.append(
            $("<input>", {
              type: "hidden",
              name: "_method",
              value: "DELETE",
            }),
          );

          // Add selected IDs as hidden inputs
          selectedIds.forEach((id) => {
            form.append(
              $("<input>", {
                type: "hidden",
                name: "id[]",
                value: id,
              }),
            );
          });

          // Append form to body and submit
          $("body").append(form);
          form.submit();
        }
      });
    });
  }
}

export function LoadPage() {
  InitPage("geiger_list", () => {
    const bulk = new BulkActions();
    bulk.init();
  });
}
